import React, { useState, useEffect } from "react";
import { getcctv } from "../../services/truckscale";
import Player from "./player";

const MainCCTV = (props) => {

  const [cctvlist, setcctvlist] = useState([]);
  const Id = props.match.params.id;
  useEffect(() => {
    if (!Id) return
    const loadData = async () => {
      try {
        const { data: result } = await getcctv(Id);

        if (result.status ==="success") {
          setcctvlist(result.data.list);
        } else {
          setcctvlist([]);
        }
      } catch (ex) {
        
      }
    };
    loadData();
  }, [Id]);
  return (
    <>
      <div className="col-auto">
        <div className="form-group">
       
        </div>
      </div>

      {cctvlist && cctvlist.length > 0 && (
        <div className="container-fluid d-flex justify-content-center">
            <div className="col-lg-8">
              <div className="m-1">
                <Player autoplay ={true} url={cctvlist[0].hlsss}               
                />
              </div>
            </div>
          
                            
        </div>
      )}
    </>
  );
};

export default MainCCTV;
